import React from 'react'

const DeleteIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2.5H8C8 1.94772 7.55228 1.5 7 1.5C6.44772 1.5 6 1.94772 6 2.5ZM5 2.5C5 1.39543 5.89543 0.5 7 0.5C8.10457 0.5 9 1.39543 9 2.5H13C13.2761 2.5 13.5 2.72386 13.5 3C13.5 3.27614 13.2761 3.5 13 3.5H12.4364L11.2313 12.3378C11.0624 13.5765 10.0044 14.5 8.75422 14.5H5.24578C3.99561 14.5 2.93762 13.5765 2.76871 12.3378L1.56355 3.5H1C0.723858 3.5 0.5 3.27614 0.5 3C0.5 2.72386 0.723858 2.5 1 2.5H5ZM6 6C6 5.72386 5.77614 5.5 5.5 5.5C5.22386 5.5 5 5.72386 5 6V11C5 11.2761 5.22386 11.5 5.5 11.5C5.77614 11.5 6 11.2761 6 11V6ZM8.5 5.5C8.77614 5.5 9 5.72386 9 6V11C9 11.2761 8.77614 11.5 8.5 11.5C8.22386 11.5 8 11.2761 8 11V6C8 5.72386 8.22386 5.5 8.5 5.5ZM3.75954 12.2027C3.86089 12.9459 4.49568 13.5 5.24578 13.5H8.75422C9.50432 13.5 10.1391 12.9459 10.2405 12.2027L11.4272 3.5H2.57281L3.75954 12.2027Z"
        fill="#F36464"
      />
    </svg>
  )
}

export default DeleteIcon
